<template>
  <div class="flex-order">
    <d-navbar-nav class="flex-row">
      <notification-nav />
      <!-- <li class="nav-item dropdown">
        <a class="nav-link dropdown-toggle text-nowrap px-3 min-w-160" v-d-toggle.user-actions>
          <img class="user-avatar rounded-circle mr-2" :src="user.picture" alt="User Avatar" />
          <span class="d-none d-md-inline-block">{{user.name}}</span>
        </a>
        <d-collapse id="user-actions" class="dropdown-menu dropdown-menu-small">
          <d-dropdown-item style="cursor: pointer" :to="{ name: 'user-profile' }">
            <i class="material-icons">&#xE7FD;</i> Mon compte
          </d-dropdown-item>
          <d-dropdown-divider />
          <d-dropdown-item class="text-danger">
            <span @click="logout">
              <i class="material-icons text-danger">&#xE879;</i> Déconnexion
            </span>
          </d-dropdown-item>
        </d-collapse>
      </li> -->
    </d-navbar-nav>
  </div>
</template>

<script>
import NotificationNav from '../../notification/notificationNav';

export default {
  name: 'nav-bar-nav',
  components: { NotificationNav },
  computed: {
    user() {
      return this.$store.state.user.informations;
    },
  },
  mounted() {
    this.emitConnection();
  },
  methods: {
    emitConnection() {
      // We're waiting a bit that the store is populate in case of refresh
      if (!this.user.reference && !this.user.token) {
        setTimeout(() => {
          this.emitConnection();
        }, 350);
      } else {
        this.$socket.emit('connected_user', {
          reference: this.user.reference,
          token: this.user.token,
        });
      }
    },
    logout() {
      this.$socket.emit('close_user', { reference: this.user.reference });
      this.$services.user.logout().then(() => {
        this.$router.push('/login');
      });
    },
  },
};
</script>

<style lang="scss">
.nav-link:hover {
  cursor: pointer;
}
/* IE11 Navbar flex fix. */
@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
  .navbar-nav {
    align-items: stretch !important;
    flex: 1 1 100%;
    flex-flow: row wrap;
  }
  .nav-item.notifications {
    margin-left: auto !important;
  }
}
.min-w-160 {
  min-width: 160px !important;
}
.flex-order {
  @media (max-width: 768px) {
    order: 2;
  }
}
</style>
